var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"lp-spinner"},_vm._l((12),function(idx){return _c('div',{key:'spn-'+idx})}),0)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }